import {colors} from '../../colors/colors';
import type {Color} from '../../typography/body';

import type {CalendarHeatmapDay, CalendarHeatmapColorVariant} from './types';

const COLOR_VARIANTS = {
    blue: {
        rgb: '32, 50, 200',
        textColor: 'navy-dk',
    },
    pink: {
        rgb: '163, 11, 115',
        textColor: 'medium',
    },
};
const HEATMAP_ALPHAS = [0.08, 0.13, 0.2, 0.32, 0.45, 0.58, 0.7, 0.8, 0.9, 1];

export function getBackgroundColor(
    day: CalendarHeatmapDay | undefined,
    colorVariant: CalendarHeatmapColorVariant
): string | undefined {
    if (!day) return undefined;
    if (day.heatmap === 0) return colors.offWhiteMd;

    return `rgba(${COLOR_VARIANTS[colorVariant].rgb}, ${HEATMAP_ALPHAS[day.heatmap - 1]})`;
}

export function getTextColor(
    day: CalendarHeatmapDay | undefined,
    colorVariant: CalendarHeatmapColorVariant
): Color {
    if (!day) return 'light';

    if (day.heatmap === 0) return 'medium';

    if (day.heatmap < 6) return COLOR_VARIANTS[colorVariant].textColor as Color;

    return 'white';
}

export function groupByMonth(dates: CalendarHeatmapDay[]): CalendarHeatmapDay[][] {
    const map = new Map<string, CalendarHeatmapDay[]>();
    for (const day of dates) {
        const key = day.date.slice(0, 7);
        const group = map.get(key) ?? [];
        group.push(day);
        map.set(key, group);
    }
    return Array.from(map.values());
}
